"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var VideoRecorderStore = /*#__PURE__*/function () {
  function VideoRecorderStore(stream, onHandleData) {
    (0, _classCallCheck2["default"])(this, VideoRecorderStore);
    this.recorder = new MediaRecorder(stream, {
      mimeType: this.supportedMimeType(),
      audioBitsPerSecond: _constants.Constants.AUDIO_BITS_PER_SECOND,
      videoBitsPerSecond: _constants.Constants.VIDEO_BITS_PER_SECOND
    });
    this.recorder.ondataavailable = onHandleData;
  }
  return (0, _createClass2["default"])(VideoRecorderStore, [{
    key: "supportedMimeType",
    value: function supportedMimeType() {
      var selectedMimeType = '';
      var mimeTypes = ['video/webm;codecs=vp8', 'video/webm'];
      (0, _lodash.each)(mimeTypes, function (mimeType) {
        if ((0, _utils.isBlank)(selectedMimeType) && MediaRecorder.isTypeSupported(mimeType)) {
          selectedMimeType = mimeType;
        }
      });
      return selectedMimeType;
    }
  }, {
    key: "createBlob",
    value: function createBlob(data) {
      return new Blob(data, {
        type: 'video/webm'
      });
    }
  }, {
    key: "record",
    value: function record() {
      this.recorder.start(10); // 10 ms of data
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.recorder.state !== 'inactive') {
        this.recorder.stop();
      }
    }
  }]);
}();
var _default = exports["default"] = VideoRecorderStore;